import { render, staticRenderFns } from "./DatasetCardHeaderStatusBar.vue?vue&type=template&id=0676bf06&"
import script from "./DatasetCardHeaderStatusBar.vue?vue&type=script&lang=js&"
export * from "./DatasetCardHeaderStatusBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports